const CollectRequest = ({ payerAccount }) => {
    return (
        <div>
            <h3 className='text-center text-success my-4'>Payment Collect Request sent to <strong>{payerAccount}</strong></h3>
           
        </div>
    )
}

export default CollectRequest;